// DID YOU MEAN — the one source (TW-0152, 2026-09-10). Generated byte-identical copies ride beside
// the code that reads them — apps/marketing/lib/, apps/form/src/, apps/app/lib/ — and a test on each
// side fails when a copy drifts from this file (the day.ts / consent-sentences-es.json shape: edit
// HERE, then cp to all three).
//
// WHY IT EXISTS. A shop owner types their address once, on a phone, from an ad — and a typo in it is
// silent on our side and total on theirs. Chris, 2026-09-10: "i figure it should be at the time of
// request rather than a script" · "because they might not get an email and think it's our fault."
// That is not hypothetical. House of Evans signed up at 04:31 that morning as `@gnail.com`, got the
// welcome three seconds later at a squatter in China, tried again six minutes later with the right
// address, and was told "House of Evans is ALREADY on waivers.tattoo." Joshua Clark of Excalibur Art
// Collective typed `@ail.com` the day before and it took a Facebook comment for anyone to find out.
//
// SUGGEST, NEVER REWRITE. The suggestion goes under the field with one tap to take it; typing on
// past it is always allowed. Nobody's address is ever changed on their behalf — a domain we have
// never heard of is far more likely to be real than to be a typo.
//
// THE THRESHOLD IS DISTANCE 1, AND THE DATA CHOSE IT. Measured over all 6,773 client records on
// 2026-09-10 — every domain within edit distance 2 of a big provider:
//   distance 1 — 23 distinct domains, 34 rows, EVERY ONE a genuine typo (gnail, gamil, gmail.con,
//                gmai, gmaip, gmsil, gmwil, gmail.cm/.co/.fom/.vom, iloud, icoud, icooud, icloud.co,
//                hotmal, yahoo.cm/.con/.comm, live.con)
//   distance 2 — 7 distinct domains, and FIVE ARE REAL: myyahoo.com (4 rows), hey.com, cs.com,
//                outlook.fr, swbc.com. Suggesting at distance 2 would tell four people their working
//                Yahoo address is wrong.
// So distance 2 is off, and the two typos it would have caught are worth losing.
//
// AND MX IS NOT THE TEST — this is the trap to not fall into. Typosquatters register these exact
// domains BECAUSE people mistype them: gnail.com, gamil.com, gmai.com, iloud.com and gmail.co all
// answer MX. `gnail.com` resolves to mx2.oweb.cn. An MX check would have waved through the address
// that broke House of Evans this morning, and every squatter's inbox holds a real shop's welcome.
//
// THE NAME IN FRONT OF THE @ (2026-09-29). Everything above argues with the PROVIDER. For nineteen days
// nothing read the half in front of it, because a mailbox name has nothing to be compared with, except
// at the one box where it does: a shop picked from the Google search has a name, and four owners in ten
// build their address out of it. Puzzle Peace Tattoos signed up that morning as `puzlle…@gmail.com` and
// the welcome bounced inside the same second. Chris: "i saw it was a typo of "puzzle" ... i'm not sure
// how many typoes we check, but i'm surprised it wasn't caught." · "i thought we could likely make sure to
// check all words from a Google Place because Puzzle would have been caught" · "and being too aggressive
// would be annoying."
//
// MEASURED THAT MORNING over every signup: 255 typed an address, 237 distinct address-and-shop pairs, 166
// of them a Google pick, and in 92 the mailbox carries one of the shop's own words. Seven owner addresses
// have ever bounced at signup:
//   1  the provider, one slip (`@gnail.com`): the rule above, since 09-10
//   2  a word of the shop's own name, one slip: Tattoo Nation on 09-18 (`tattoo.ation…`, a dot where the n
//      belongs) and Puzzle Peace on 09-29. This rule offers each the mailbox the shop ended on.
//   4  no typo of anything the box knows: three are the shop's name spelled RIGHT at a mailbox that does
//      not exist or has died, one is hello@ at the shop's real domain. Only the bounce finds those, and
//      the banner in the shop app is what tells the owner (apps/app/lib/dead-email-banner.ts).
// And of the 237 it questions one, the real one.
//
// THE TRADE'S OWN WORDS ARE CHECKED TOO, and the floor is what makes that safe. Chris, the same morning:
// "tattoo is easy to typo in my experience, and is exceedingly common so dunno there but i typo it often".
// 63 of the 237 mailboxes carry `tattoo` spelled right and one carries it a slip off: `…tatoo…`, a working
// address, an artist's own handle at a shop whose name it does not otherwise share. So a slip is asked
// about only when the mailbox, as offered, is BUILT FROM THE SHOP'S WORDS: two thirds of its letters or
// more. That address stands at 55%; the two real typos at 100% and 80%.
//
// WHAT IS NEVER A SOURCE. The person's own name: measured, 5 of 205 questioned and all five were working
// addresses (Chad and Char, George and Jorge). A word under 5 letters, a word with a digit in it, a word that
// is there in another form (`angel` for Angels, `karma` for Karma's). Until 2026-10-18 a shop name somebody
// TYPED was on this list too, because it can carry the same slip as the address under it, and moving a right
// address to match a mistyped name is worse than saying nothing. It is read now, at its own bar (below).
//
// A NAME SOMEBODY TYPED (2026-10-18). Brags Design landed on /start from a Google ad at 8:28pm EDT, typed its
// own name (nothing picked from the search) and, at 8:30, a Yahoo mailbox that is the shop's name with the e of
// "design" missing. The welcome bounced "mailbox not found" inside the same second, and this box said nothing,
// because a typed name was never a source. Chris: "Oh brags missed the e in the email." · "I'm surprised you
// didn't see that? Or our automated checks." · "Maybe we can typo check if it's a manual entry because Design
// was in the name." · "But dsign could have caught that methinks even if manual." So a typed name is read
// too, at a NARROWER bar than a listing's, because it can carry the slip itself: a word of 6 letters or more,
// and only a letter DROPPED (`dsign`), a letter DOUBLED (`dessign`) or two letters the WRONG WAY ROUND
// (`desgin`); never the key next door, another letter, or a digit for a letter, which is how a handle gets
// built (`p3rfecto`). And never when what the mailbox has there is one of the trade's own words spelled right
// (TRADE_SPELLINGS): then it is the NAME that slipped (`Peircing`, `Galery`), or both are right (`Parlour`
// and `parlor`). The floor, the letter beside the word and everything else above hold as they do for a listing.
//
// MEASURED THAT NIGHT over every signup: 304 distinct address-and-shop pairs, 223 with a listing picked and 81
// with a name typed. The listing's own bar handed the typed name asks about 2 of the 81: Brags Design, dead,
// and a working Gmail that writes the shop's name with a 3 for an e, whose owner signs in with it. This bar
// asks about 1, the real one; run over all 304 as though every name had been typed, still 1. And a listing's
// name catches Brags at its own bar too ("I assume our automated place check would have caught it": it would).
//
// THE SHOP'S OWN DOMAIN is the same idea after the @. 12 of the 12 owners who typed an address at their
// own domain, and whose listing names a website, typed that website's domain. So an address ONE slip from
// the listing's domain is asked about (`@kellertatoo.com`), and never one that differs by a hyphen or a
// plural, which is a second domain somebody bought. Nothing in our rows has needed it yet.

/** The domains worth arguing with. A domain that is NOT here is never suggested against, and a
 *  domain that IS here is never questioned — so the list's job is to be right, not to be long.
 *  Every one our own rows actually carry is in it, which is what keeps a real address quiet. */
export const KNOWN_DOMAINS = [
  // the ones that carry our shops and their clients, in order of how many
  'gmail.com', 'yahoo.com', 'icloud.com', 'hotmail.com', 'outlook.com', 'aol.com', 'live.com',
  'comcast.net', 'att.net', 'me.com', 'ymail.com', 'sbcglobal.net', 'rocketmail.com', 'msn.com',
  'proton.me', 'protonmail.com', 'mail.com', 'aim.com', 'googlemail.com', 'myyahoo.com',
  'verizon.net', 'cox.net', 'charter.net', 'earthlink.net', 'bellsouth.net', 'twc.com', 'juno.com',
  'netscape.com', 'cs.com', 'hey.com', 'mac.com', 'roadrunner.com', 'optonline.net', 'frontier.com',
  'windstream.net', 'centurylink.net', 'suddenlink.net', 'embarqmail.com', 'zoho.com', 'fastmail.com',
  'gmx.com', 'yandex.com', 'duck.com', 'pm.me', 'outlook.es', 'hotmail.es',
  // Canada and the UK, where a shop or a travelling client turns up
  'rogers.com', 'shaw.ca', 'sympatico.ca', 'telus.net', 'yahoo.ca', 'hotmail.ca', 'live.ca',
  'yahoo.co.uk', 'hotmail.co.uk', 'live.co.uk', 'btinternet.com', 'sky.com', 'virginmedia.com',
];

/** The five people actually mistype, and the only ones the prefix/suffix rule below will complete.
 *  `ail.com` -> `gmail.com` is the case that put this here and no edit distance under 2 finds it. */
const BIG = ['gmail', 'yahoo', 'hotmail', 'icloud', 'outlook'];

const known = new Set(KNOWN_DOMAINS);

/** Damerau-Levenshtein — transposition counts as one, because `gamil` for `gmail` is one slip of
 *  two fingers and plain Levenshtein calls it two. */
function distance(a: string, b: string): number {
  const la = a.length;
  const lb = b.length;
  const d: number[][] = Array.from({ length: la + 1 }, () => new Array(lb + 1).fill(0));
  for (let i = 0; i <= la; i++) d[i][0] = i;
  for (let j = 0; j <= lb; j++) d[0][j] = j;
  for (let i = 1; i <= la; i++) {
    for (let j = 1; j <= lb; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
      }
    }
  }
  return d[la][lb];
}

/** Whitespace around an address is never meaningful, so this one IS applied silently, on both sides
 *  of the wire. Two client rows are stored today as ` icloud.com` and ` yahoo.com` — a leading space
 *  that survived into the table and makes every send to them bounce. */
export function tidyEmail(typed: string): string {
  const address = `${typed ?? ''}`.replace(/[\u200B-\u200D\uFEFF]/g, '').trim();
  const at = address.lastIndexOf('@');
  // the domain is case-insensitive by spec, so lowering it is a fix and never a question. The local
  // part is left exactly as typed: `Rae.Quinn@` is how they write their own name.
  return at < 1 ? address : `${address.slice(0, at)}@${address.slice(at + 1).toLowerCase()}`;
}

/** The domain with the things that cannot appear in one turned into what was meant: a comma or a
 *  space typed for the dot, a doubled or trailing dot. Each is in our rows (`gmail,com`,
 *  `gmail com`, `icloud .con`) and none of them is a judgement call — a space is not deleted but
 *  made a dot, which is what `gmail com` meant and what leaves `icloud .con` as `icloud.con`. */
function normalizeDomain(domain: string): string {
  return domain
    .toLowerCase()
    .replace(/\s+/g, '.')
    .replace(/,/g, '.')
    .replace(/\.{2,}/g, '.')
    .replace(/^\.+|\.+$/g, '');
}

/** The provider they probably meant, or null. Null is the common answer and the safe one: an unknown
 *  domain is left alone. */
function meantProvider(typedDomain: string): string | null {
  const domain = normalizeDomain(typedDomain);
  if (!domain) return null;
  const offer = (d: string) => (d === typedDomain ? null : d);

  // it is a real domain. The only thing left to fix is how it was typed (a comma, a stray space).
  if (known.has(domain)) return offer(domain);

  // no TLD at all — `you@gmail`, which the browser's own type=email check accepts and 6 of our
  // client rows carry. Only completed when the whole thing is a provider we know by name.
  if (!domain.includes('.')) {
    const whole = KNOWN_DOMAINS.find((k) => k.split('.')[0] === domain);
    return whole ? offer(whole) : null;
  }

  const label = domain.slice(0, domain.indexOf('.'));
  const tld = domain.slice(domain.indexOf('.') + 1);

  // one slip. Short labels are left alone — at three characters or fewer nearly everything is one
  // slip from something, and that is where a real address gets argued with.
  if (label.length >= 4) {
    for (const candidate of KNOWN_DOMAINS) {
      if (distance(domain, candidate) <= 1) return offer(candidate);
    }
  }

  // the phone ate the front or the end of the provider's name — `ail.com` for `gmail.com`, which is
  // two edits away and would never be caught above. Only the five people really mistype, only when
  // the rest of the domain already matches, and only when at most two characters went missing.
  for (const big of BIG) {
    const whole = KNOWN_DOMAINS.find((k) => k.split('.')[0] === big && k.slice(big.length + 1) === tld);
    if (!whole) continue;
    if (label.length < 3 || label.length >= big.length) continue;
    if (big.length - label.length > 2) continue;
    if (big.endsWith(label) || big.startsWith(label)) return offer(whole);
  }

  return null;
}

// ── THE NAME IN FRONT OF THE @ ────────────────────────────────────────────────────────────────────

/** What the box knows about the shop whose address this is: the name and the website ON ITS GOOGLE
 *  LISTING, only ever from a listing the owner picked; or, with no listing picked, the name somebody
 *  typed (`typedShop`, 2026-10-18), which is read at its own narrower bar (the header has why). With
 *  nothing passed, only the provider is argued with, as before 2026-09-29. */
export type About = {
  shop?: string | null;
  website?: string | null;
  /** The listing's city. 11 of the 255 mailboxes carry theirs (`…tattooaugusta`), so its letters count
   *  as the shop's when the floor is read. It is never itself argued about: a Justin in Austin is
   *  one letter from his own city. */
  city?: string | null;
  /** The shop's name as somebody TYPED it, with no listing picked (2026-10-18, Brags Design). Read only
   *  when there is no listing's `shop`, and at the TYPED bar: a listing's name, when there is one, wins. */
  typedShop?: string | null;
};

/** Which rule moved the address, for the beacon: the provider after the @, a word of the shop's own
 *  name in front of it (a listing's, or since 2026-10-18 one somebody typed), the shop's own domain. */
export type Because = 'provider' | 'shop-words' | 'typed-name' | 'own-domain';

export type Meant = {
  /** the whole address, ready to put in the field */
  address: string;
  because: Because[];
  /** the address in runs, the moved ones marked, so a screen can show WHICH letters it is asking
   *  about: one letter in an 18-letter mailbox is not something a person finds by eye on a phone */
  parts: Array<{ text: string; moved: boolean }>;
};

/** A word shorter than this is never argued about: `rose` is one slip from nose, role, rise and rows. */
const WORD_MIN = 5;
/** And in a name somebody typed, a word shorter than this (2026-10-18): `design` is the shortest the bar was
 *  set for, and a typed name has no listing behind it to say it was spelled right. */
const TYPED_WORD_MIN = 6;
/** The share of a mailbox's letters that must be the shop's own words before a slip in it is asked
 *  about. Measured 2026-09-29: the one working address a slip from its shop's word stands at 0.55,
 *  the two real typos at 1.00 and 0.80. */
const BUILT_FROM = 2 / 3;

/** A phone's keyboard, the rows as they sit: the middle row half a key in, the bottom one and a half.
 *  Two keys are neighbours when a thumb on one can land on the other. */
const ROWS = ['qwertyuiop', 'asdfghjkl', 'zxcvbnm'];
const INSET = [0, 0.5, 1.5];
function neighbours(a: string, b: string): boolean {
  let ra = -1;
  let rb = -1;
  for (let r = 0; r < ROWS.length; r++) {
    if (ROWS[r].indexOf(a) >= 0) ra = r;
    if (ROWS[r].indexOf(b) >= 0) rb = r;
  }
  if (ra < 0 || rb < 0 || Math.abs(ra - rb) > 1) return false;
  const across = Math.abs(ROWS[ra].indexOf(a) + INSET[ra] - (ROWS[rb].indexOf(b) + INSET[rb]));
  return ra === rb ? across === 1 : across <= 1;
}

/** Every word of a shop's name, lowercased, in the name's order, each once: accents and apostrophes
 *  out (`Karma's` is karmas, `Café` is cafe), `&` read as the word it stands for. */
function shopWords(name: string): string[] {
  const plain = `${name ?? ''}`
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/['\u2019`]/g, '')
    .replace(/&/g, ' and ');
  const out: string[] = [];
  for (const word of plain.split(/[^a-z0-9]+/)) {
    if (word.length >= 3 && !/^\d+$/.test(word) && out.indexOf(word) < 0) out.push(word);
  }
  return out;
}

/** `angel` for angels, `karma` for karmas: the form a mailbox carries as often as the name's own. */
const singular = (word: string): string => (word.length > 4 && word.endsWith('s') ? word.slice(0, -1) : '');

/** How one slip turns what was typed into the word, best guess first, or 0 when it is not one slip.
 *    1  two letters the wrong way round (`puzzel`)
 *    2  the key next door (`puzzlw`)
 *    3  a letter missing or a letter extra (`puzle`, `puzzzle`)
 *    4  another letter altogether (`puzlle`), and anything typed that is not a letter
 *  The order only ever breaks a tie between two readings of the same mailbox. */
function slipKind(typed: string, word: string): number {
  if (typed === word) return 0;
  if (typed.length === word.length) {
    const off: number[] = [];
    for (let i = 0; i < word.length; i++) if (typed[i] !== word[i]) off.push(i);
    if (off.length === 1) return neighbours(typed[off[0]], word[off[0]]) ? 2 : 4;
    const swapped = off.length === 2 && off[1] === off[0] + 1 && typed[off[0]] === word[off[1]] && typed[off[1]] === word[off[0]];
    return swapped ? 1 : 0;
  }
  const [short, long] = typed.length < word.length ? [typed, word] : [word, typed];
  if (long.length - short.length !== 1) return 0;
  let i = 0;
  while (i < short.length && short[i] === long[i]) i++;
  return short.slice(i) === long.slice(i + 1) ? 3 : 0;
}

/** The three slips a name somebody typed is read for (2026-10-18): a letter DROPPED (`dsign`), a letter
 *  DOUBLED (`dessign`), two letters the WRONG WAY ROUND (`desgin`). Never the key next door, another letter, or
 *  a digit for a letter: a mailbox that writes the shop's name with a 3 for an e is a handle, and it works. */
function droppedDoubledOrSwapped(typed: string, word: string): boolean {
  const kind = slipKind(typed, word);
  if (typed.length === word.length) return kind === 1;
  if (kind !== 3) return false;
  if (typed.length < word.length) return true;
  // one letter over: a slip of this kind only when it is the letter beside it again
  let i = 0;
  while (i < word.length && typed[i] === word[i]) i++;
  return typed[i] === typed[i - 1] || typed[i] === typed[i + 1];
}

/** The trade's own words as a mailbox spells them RIGHT: the words of 6 letters or more that our shops' names
 *  carry most (measured 2026-10-18 over 355 names: tattoo 175, studio 43, tattoos 38, piercing 24, company 13,
 *  collective 11, …), each with its other spelling where it has one. Where a typed name has a word one slip
 *  from one of these and the mailbox has THIS, it is the name that slipped (`Peircing`, `Galery`), or both are
 *  right (`Parlour`, `parlor`), and the box is quiet: moving a right address to match a mistyped name is worse
 *  than saying nothing. A listing's name is Google's and needs none of this. */
const TRADE_SPELLINGS = new Set([
  'tattoo', 'tattoos', 'tattooing', 'studio', 'studios', 'piercing', 'piercings', 'company', 'collective',
  'street', 'parlor', 'parlors', 'parlour', 'parlours', 'gallery', 'galleries', 'lounge', 'custom', 'customs',
  'design', 'designs', 'artistry', 'electric', 'tradition', 'traditional', 'needle', 'needles', 'beauty',
  'industry', 'color', 'colors', 'colour', 'colours', 'jewelry', 'jewellery',
]);

/** How a name is read: the shortest word argued about, and which stretches of a mailbox count as one slip
 *  from a word of it. */
type Bar = { wordMin: number; slip: (typed: string, word: string) => boolean };
/** A listing's name is the shop's own, as Google has it: every word of 5 letters or more, every kind of slip. */
const LISTING: Bar = { wordMin: WORD_MIN, slip: () => true };
/** A name somebody typed can carry the slip itself, so it is read narrower (the header has why). */
const TYPED: Bar = {
  wordMin: TYPED_WORD_MIN,
  slip: (typed, word) => !TRADE_SPELLINGS.has(typed) && droppedDoubledOrSwapped(typed, word),
};

type Slip = { from: number; to: number; word: string; kind: number; over: number };

/** Which characters of a mailbox are the shop's own words, spelled right, in either form. */
function owned(lower: string, words: string[]): boolean[] {
  const mine: boolean[] = [];
  for (const word of words) {
    for (const form of [word, singular(word)]) {
      if (form.length < 3) continue;
      for (let at = lower.indexOf(form); at >= 0; at = lower.indexOf(form, at + 1)) {
        for (let i = at; i < at + form.length; i++) mine[i] = true;
      }
    }
  }
  return mine;
}

const isLetter = (c: string | undefined): boolean => c !== undefined && c >= 'a' && c <= 'z';

/** How many of a mailbox's LETTERS are nobody's: not one of the shop's own words. Digits, dots and
 *  dashes are not letters. */
function lettersOver(lower: string, words: string[]): { letters: number; over: number } {
  const mine = owned(lower, words);
  let letters = 0;
  let over = 0;
  for (let i = 0; i < lower.length; i++) {
    if (!isLetter(lower[i])) continue;
    letters += 1;
    if (!mine[i]) over += 1;
  }
  return { letters, over };
}

/** The share of a mailbox's letters that are the shop's own words. It is read off the mailbox AS
 *  OFFERED, so a word that was a slip away counts as the word it is about to be. */
function builtFrom(lower: string, words: string[]): number {
  const { letters, over } = lettersOver(lower, words);
  return letters ? (letters - over) / letters : 0;
}

/** A reading that leaves ONE letter over, right beside the word, has not explained what they typed:
 *  `puzlel` read as a missing z leaves an l behind it, and the offer would be another wrong address.
 *  A plural's s is theirs to keep, and so is anything longer (`llc`, `co`, a city). */
function leavesOneOver(offered: string, from: number, to: number, words: string[]): boolean {
  const mine = owned(offered, words);
  let after = 0;
  for (let i = to; isLetter(offered[i]) && !mine[i]; i++) after += 1;
  let before = 0;
  for (let i = from - 1; isLetter(offered[i]) && !mine[i]; i--) before += 1;
  return (after === 1 && offered[to] !== 's') || before === 1;
}

/** The stretch of the mailbox that is one slip from this word, or null. When two readings fit
 *  (`puzzlpeace…` is a missing e, or a p typed for the e), the one that leaves the fewest letters
 *  unexplained wins, then the likelier slip, then the first. Only the slips the bar reads count. */
function slipFor(lower: string, word: string, words: string[], bar: Bar): Slip | null {
  let best: Slip | null = null;
  for (const size of [word.length, word.length - 1, word.length + 1]) {
    for (let from = 0; from + size <= lower.length; from++) {
      const stretch = lower.slice(from, from + size);
      const kind = slipKind(stretch, word);
      if (!kind || !bar.slip(stretch, word)) continue;
      const offered = lower.slice(0, from) + word + lower.slice(from + size);
      if (leavesOneOver(offered, from, from + word.length, words)) continue;
      const over = lettersOver(offered, words).over;
      if (!best || over < best.over || (over === best.over && kind < best.kind)) {
        best = { from, to: from + size, word, kind, over };
      }
    }
  }
  return best;
}

/** The word, in the shape of what was typed over it: `Puzlle` is asked about as `Puzzle`. */
function shaped(word: string, typed: string): string {
  const letters = typed.replace(/[^A-Za-z]/g, '');
  if (letters && letters === letters.toUpperCase() && letters.length > 1) return word.toUpperCase();
  if (typed[0] && typed[0] !== typed[0].toLowerCase()) return word[0].toUpperCase() + word.slice(1);
  return word;
}

/** The mailbox they probably meant, and where in it the moved words sit; or null. */
function meantMailbox(local: string, shop: string, city: string, bar: Bar): { local: string; moved: Array<[number, number]> } | null {
  const words = shopWords(shop);
  // whose letters a mailbox is made of: the name's words, and the city's beside them
  const theirs = words.slice();
  for (const word of shopWords(city)) if (theirs.indexOf(word) < 0) theirs.push(word);
  let fixed = local;
  const moved: Array<[number, number]> = [];
  for (const word of words) {
    if (word.length < bar.wordMin || !/^[a-z]+$/.test(word)) continue;
    const lower = fixed.toLowerCase();
    const one = singular(word);
    // spelled right, in the name's form or the other one: nothing to ask
    if (lower.includes(word) || (one && lower.includes(one))) continue;
    // the name's own form first; the other only when the name's form is not there to be found
    // (`…tatoo` at Puzzle Peace Tattoos is offered `…tattoo`, the form they typed)
    const slip = slipFor(lower, word, theirs, bar) ?? (one.length >= bar.wordMin ? slipFor(lower, one, theirs, bar) : null);
    if (!slip) continue;
    const put = shaped(slip.word, fixed.slice(slip.from, slip.to));
    const grew = put.length - (slip.to - slip.from);
    fixed = fixed.slice(0, slip.from) + put + fixed.slice(slip.to);
    for (const span of moved) {
      if (span[0] >= slip.to) {
        span[0] += grew;
        span[1] += grew;
      }
    }
    moved.push([slip.from, slip.from + put.length]);
  }
  if (!moved.length || fixed === local) return null;
  // and only when the mailbox is the shop's name to begin with: a slip in somebody's own handle is theirs
  if (builtFrom(fixed.toLowerCase(), theirs) < BUILT_FROM) return null;
  moved.sort((a, b) => a[0] - b[0]);
  return { local: fixed, moved };
}

/** The host a website sits on, lowercased, `www.` off: `http://www.KellerTattoo.com/book` is
 *  kellertattoo.com. '' for what is not one. */
function hostOf(website: string): string {
  let host = `${website ?? ''}`.trim().toLowerCase();
  host = host.replace(/^[a-z][a-z0-9+.-]*:\/\//, '');
  host = host.split(/[/?#]/)[0];
  host = host.slice(host.lastIndexOf('@') + 1).split(':')[0].replace(/\.+$/, '');
  return host.indexOf('www.') === 0 ? host.slice(4) : host;
}

/** The shop's own domain, when the one typed is a single slip from it; or null. A hyphen's or a
 *  plural's difference is never a slip: a shop that owns ironandink.com often owns iron-and-ink.com. */
function meantOwnDomain(domain: string, website: string): string | null {
  const host = hostOf(website);
  const labels = host.split('.');
  // the host, and every shorter tail of it that is still a whole domain (book.ironandink.com, then
  // ironandink.com)
  const tails: string[] = [];
  for (let i = 0; i + 2 <= labels.length; i++) tails.push(labels.slice(i).join('.'));
  if (tails.indexOf(domain) >= 0) return null;
  for (const tail of tails) {
    const label = tail.slice(0, tail.indexOf('.'));
    if (label.length < 4 || known.has(tail) || distance(domain, tail) !== 1) continue;
    if (domain.replace(/-/g, '') === tail.replace(/-/g, '')) continue;
    const typedLabel = domain.slice(0, domain.indexOf('.'));
    const rest = (d: string) => d.slice(d.indexOf('.'));
    if (rest(domain) === rest(tail) && (typedLabel === `${label}s` || label === `${typedLabel}s`)) continue;
    return tail;
  }
  return null;
}

/**
 * What they probably meant and why, or null. The address comes back whole, ready to put in the
 * field: everything exactly as they typed it except the provider, or a word of the shop's own name
 * (a listing's, or one somebody typed), or the shop's own domain.
 *
 * Null is the common answer and the safe one.
 */
export function explainEmail(typed: string, about?: About | null): Meant | null {
  const address = tidyEmail(typed);
  const at = address.lastIndexOf('@');
  if (at < 1 || at === address.length - 1) return null;
  const local = address.slice(0, at);
  const typedDomain = address.slice(at + 1);
  if (local.includes('@')) return null;
  const domain = normalizeDomain(typedDomain);
  if (!domain) return null;

  const because: Because[] = [];
  // the listing's name; or, with no listing picked, the name somebody typed, at its own bar (2026-10-18)
  const listed = about && about.shop ? about.shop : '';
  const typedName = !listed && about && about.typedShop ? about.typedShop : '';
  const mailbox = listed
    ? meantMailbox(local, listed, (about && about.city) || '', LISTING)
    : typedName
      ? meantMailbox(local, typedName, '', TYPED)
      : null;
  if (mailbox) because.push(listed ? 'shop-words' : 'typed-name');
  let meant = meantProvider(typedDomain);
  if (meant) because.push('provider');
  else if (about && about.website && !known.has(domain)) {
    meant = meantOwnDomain(domain, about.website);
    if (meant) because.push('own-domain');
  }
  if (!because.length) return null;

  const parts: Meant['parts'] = [];
  const name = mailbox ? mailbox.local : local;
  let drawn = 0;
  for (const [from, to] of mailbox ? mailbox.moved : []) {
    if (from > drawn) parts.push({ text: name.slice(drawn, from), moved: false });
    parts.push({ text: name.slice(from, to), moved: true });
    drawn = to;
  }
  parts.push({ text: `${name.slice(drawn)}@`, moved: false });
  parts.push({ text: meant ?? typedDomain, moved: Boolean(meant) });
  return { address: `${name}@${meant ?? typedDomain}`, because, parts };
}

/** The address they probably meant, or null: `explainEmail` without the why. */
export function suggestEmail(typed: string, about?: About | null): string | null {
  const meant = explainEmail(typed, about);
  return meant ? meant.address : null;
}
